import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import '../../../assets/css/formula.css';
var ViewerFormula = /*#__PURE__*/function (_React$Component) {
  _inherits(ViewerFormula, _React$Component);
  var _super = _createSuper(ViewerFormula);
  function ViewerFormula() {
    var _this;
    _classCallCheck(this, ViewerFormula);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.renderFormula = function () {
      var node = _this.props.node;
      _this.formulaContainer.innerHTML = '';
      var formula = node.data.formula;
      var dom = window.MathJax.tex2svg(formula);
      _this.formulaContainer.appendChild(dom);
    };
    return _this;
  }
  _createClass(ViewerFormula, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = this.props.node;
      if (!node.data.formula) return;
      this.renderFormula();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        attributes = _this$props.attributes,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement("span", Object.assign({
        className: 'block-formula'
      }, attributes), /*#__PURE__*/React.createElement("span", {
        contentEditable: false,
        ref: function ref(_ref) {
          return _this2.formulaContainer = _ref;
        }
      }), /*#__PURE__*/React.createElement("span", {
        contentEditable: false
      }, children));
    }
  }]);
  return ViewerFormula;
}(React.Component);
export default ViewerFormula;